const getters = {
  getChannelsCustomersList: (state) => state.channelsCustomers,
  getWebhookProviderWhatsapp: (state) => state.webhookProviderWhatsapp,
  getDataParameters: (state) => state.dataParameters,
};

export default getters;
